import { QueryClient } from '@tanstack/react-query';

/** A query cache with the Studio's defaults: one for the caller, one per person preview. */
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60,
        retry: (failureCount, error) => {
          // Don't retry auth failures — token renewal handles recovery
          if (error instanceof Error && error.message.includes('Unauthorized')) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: (failureCount, error) => {
          if (error instanceof Error && error.message.includes('Unauthorized')) return false;
          return failureCount < 1;
        },
      },
    },
  });
}
